import { useTimezoneContext } from '../contexts/TimezoneContext';

/**
 * Custom hook to access timezone context
 * Must be used within TimezoneProvider
 * 
 * @returns {Object} Object with:
 *   - timezone: Current timezone string (e.g., 'America/Sao_Paulo')
 *   - setTimezone: Function to change timezone
 *   - supportedTimezones: Array of supported timezone strings
 * 
 * @throws {Error} If used outside of TimezoneProvider
 */
export function useTimezone() {
  return useTimezoneContext();
}

export default useTimezone;
